var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-collapse",class:[_vm.type],staticStyle:{"border-bottom":"rgba(218,225,231,1) 1px solid","border-radius":"0px"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }